import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../../api/axiosInstance";
import toast from "react-hot-toast";

const IgnoredProfilesCard = () => {
  const [ignoredProfiles, setIgnoredProfiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const fetchIgnoredProfiles = async () => {
    try {
      setLoading(true);
      const startTime = Date.now();

      const res = await axios.get("/api/ignored-profiles/", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });

      const elapsed = Date.now() - startTime;
      const remaining = 1000 - elapsed;
      if (remaining > 0) {
        setTimeout(() => {
          setIgnoredProfiles(res.data);
          setLoading(false);
        }, remaining);
      } else {
        setIgnoredProfiles(res.data);
        setLoading(false);
      }
    } catch (error) {
      console.error(error.response?.data || error.message);
      toast.error("Failed to fetch ignored profiles");
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchIgnoredProfiles();
  }, []);

  const displayProfiles = ignoredProfiles.slice(0, 3);
  const extraCount = ignoredProfiles.length - displayProfiles.length;

  return (
    <div className="flex flex-col md:flex-row justify-between items-center p-4 border rounded-lg bg-white shadow-sm mb-4">
      <div className="mb-3 md:mb-0">
        <h2 className="text-lg font-semibold ">
          Profiles You Marked As “Don't show” ({ignoredProfiles.length})
        </h2>
      </div>

      <div className="flex items-center space-x-2">
        {loading ? (
          <div className="flex items-center space-x-2">
            {[...Array(3)].map((_, idx) => (
              <div
                key={idx}
                className="w-10 h-10 rounded-full bg-gray-200 animate-pulse"
              ></div>
            ))}
          </div>
        ) : (
          <>
            {displayProfiles.map((profile) => (
              <img
                key={profile.id}
                src={
                  profile.photo || require("../../assets/default_image.webp")
                }
                alt={profile.user?.first_name}
                className="w-10 h-10 rounded-full object-cover border"
              />
            ))}
            {extraCount > 0 && (
              <div className="w-10 h-10 rounded-full bg-gray-100 border flex items-center justify-center text-sm text-gray-600">
                {extraCount}+
              </div>
            )}
          </>
        )}

        <button
          onClick={() => navigate("/matches-all--php-html/ignored-by-you")}
          className="ml-4 border border-orange-500 text-orange-500 rounded-full px-4 py-1 text-sm hover:bg-orange-50 transition"
        >
          View all →
        </button>
      </div>
    </div>
  );
};

export default IgnoredProfilesCard;
